module.exports = __webpack_public_path__ + "static/img/061.38a7c16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/061.png
// module id = SB59
// module chunks = 0